import { DOMcreateElement } from '../typescript/TSXDomParse';
import TicketCommitButton from './TicketCommitButton';
export default function MobileTicketButton(data, icon) {
    return (DOMcreateElement("div", { id: "mobile-ticket-cart" },
        DOMcreateElement(TicketCommitButton, { data: data, icon: icon, showTicketCount: true })));
}
